import { render, staticRenderFns } from "./bindv2.vue?vue&type=template&id=012ec9a0&scoped=true"
import script from "./bindv2.vue?vue&type=script&lang=js"
export * from "./bindv2.vue?vue&type=script&lang=js"
import style0 from "./bindv2.vue?vue&type=style&index=0&id=012ec9a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ec9a0",
  null
  
)

export default component.exports